import { render, staticRenderFns } from "./personal-data-export.component.vue?vue&type=template&id=d5b18ba8&scoped=true&"
import script from "./personal-data-export.component.vue?vue&type=script&lang=ts&"
export * from "./personal-data-export.component.vue?vue&type=script&lang=ts&"
import style0 from "./personal-data-export.component.vue?vue&type=style&index=0&id=d5b18ba8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b18ba8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAutocomplete,VBtn,VForm,VIcon,VSelect})
